import React from "react";
import EnrollmentbySite from "./Chart/EnrollmentbySite";
import RandomizationbyArm from "./Chart/RandomizationbyArm";
import { FaListOl } from "react-icons/fa";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import EIWRSRecentActivity from "./EIWRSRecentActivity";

const ModeWiseEIWRSGraph = ({ StudyMode, selected }) => {
  const roleType = JSON.parse(localStorage.getItem("role"));

  const cardData = {
    "Screened": { count: "8", subtitle: "0 screen failed" },
    "Randomized": { count: "6", subtitle: "across 3 arms" },
    "Kits — Depot": { count: "49", subtitle: "available for shipment" },
    "Kits — Site": { count: "18", subtitle: "available for dispense" },
    "In Transit": { count: "0", subtitle: "0 active shipments" },
    "Expiring ≤90d": { count: "5", subtitle: "0 already expired" }
  };

  const renderCard = (key) => {
    const data = cardData[key];
    return (
      <Form.Group as={Col} md={4} sm={6} key={key}>
        <Card className="app-card bg-light border">
          <Card.Body>
            <div className="d-flex gap-3">
              <div className="study_icon">
                <FaListOl className="bg-white shadow-sm" />
              </div>
              <div>
                <Card.Title>{key}</Card.Title>
                <Card.Text className="m-0">{data.count}</Card.Text>
                <Card.Text>{data.subtitle}</Card.Text>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Form.Group>
    );
  };

  const actionItems = [
    { text: "5 kit(s) expiring within 60 days" },
    { text: "Site 102 below resupply threshold (0/8)" },
    { text: "Site 202 below resupply threshold (0/8)" }
  ];

  return (
    <Container fluid>
      <Row className="g-2 h-100">
        {/* Dynamic cards */}
        {Object.keys(cardData).filter(key => selected.includes(key)).map(renderCard)}

        {/* Action Required */}
        {selected.includes("Action Required") && (
          <Form.Group as={Col} md={12}>
            <Card className="bg-light border">
              <h5 className="mb-0 fontSize12 p-2 border-bottom">
                <span className="text-warning">⚠️</span> Action Required
              </h5>
              <Card.Body>
                {actionItems.map((item, idx) => (
                  <Alert key={idx} className="hstack justify-content-between mb-2 app-card CP" variant="warning">
                    <span>
                      <span className="text-warning me-2">⚠️</span>{item.text}
                    </span>
                    <Button variant="link" className="p-0 text-decoration-none fw-bold text-warning" style={{ fontSize: 12 }}>
                      View →
                    </Button>
                  </Alert>
                ))}
              </Card.Body>
            </Card>
          </Form.Group>
        )}

        {/* Charts */}
        {selected.includes("Enrollment by Site") && (
          <Form.Group as={Col} md={6}>
            <Card className="app-card bg-light border mb-2">
              <h2 className="fontSize12 border-bottom p-2">Enrollment by Site</h2>
              <Card.Body><EnrollmentbySite /></Card.Body>
            </Card>
          </Form.Group>
        )}

        {selected.includes("Randomization by Arm") && (
          <Form.Group as={Col} md={6}>
            <Card className="app-card bg-light border mb-2">
              <h2 className="fontSize12 border-bottom p-2">Randomization by Arm</h2>
              <Card.Body><RandomizationbyArm /></Card.Body>
            </Card>
          </Form.Group>
        )}

        {/* Recent Activity */}
        {roleType === "ctms" && selected.includes("Recent activity") && (
          <Form.Group as={Col} md={12}>
            <Card className="border bg-light">
              <Card.Body>
                <Card.Title>Recent activity</Card.Title>
                <Card.Text className="m-0 mt-2">
                  <EIWRSRecentActivity StudyMode={StudyMode} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Form.Group>
        )}
      </Row>
    </Container>
  );
};

export default ModeWiseEIWRSGraph;